/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-08T11:03:21.502
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentMaterialReceivingMainForm,
	getRentMaterialReceivingMainFormCreateInit,
	getRentMaterialReceivingMainFormEditInit,
	getRentMaterialReceivingMainFormView,
	deleteRentMaterialReceivingMainForm,
	submitRentMaterialReceivingMainForm
} from '@api/rentmanage/RentMaterialReceivingMainForm';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

import {
listRentMaterialReceivingFormInit,
listRentMaterialReceivingFormByAuthorizations,
deleteRentMaterialReceivingForm
} from '@api/rentmanage/RentMaterialReceivingForm';

export default {
	namespaced: true,

	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentMaterialReceivingMainFormCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentMaterialReceivingMainFormCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentMaterialReceivingMainFormEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentMaterialReceivingMainFormEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentMaterialReceivingMainForm({}, RentMaterialReceivingMainForm) {
			return new Promise((resolve, reject) => {
				saveRentMaterialReceivingMainForm(RentMaterialReceivingMainForm)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		submitRentMaterialReceivingMainForm({}, RentMaterialReceivingMainForm) {
			return new Promise((resolve, reject) => {
				submitRentMaterialReceivingMainForm(RentMaterialReceivingMainForm)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		
		getRentMaterialReceivingMainFormView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentMaterialReceivingMainFormView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentMaterialReceivingMainForm({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentMaterialReceivingMainForm({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
